import React from 'react'
import type { Person } from 'shared/graphql/graphql'
import EventRestrictingAlert from '../../molecules/Alert/event-restricting-alert/event-restricting-alert'
import AbsenceRequestConflictsCard from '../absence-request-conflict-card'
import type { NewAbsenceRequestEventAlertProps } from './types'
import useNewAbsenceRequestAlerts from './use-new-absence-request-alerts'

const NewAbsenceRequestAlertContent: React.FC<NewAbsenceRequestEventAlertProps> = (props) => {
  const { startDate, endDate } = props
  const {
    validDates,
    showRestrictingEvents,
    showConflictsCard,
    selectedPerson,
    listOfRestrictingEvents,
    showAbsencePlannerDrawer,
    setShowAbsencePlannerDrawer,
  } = useNewAbsenceRequestAlerts(props)

  if (!validDates || !selectedPerson) return null

  return (
    <>
      {showRestrictingEvents &&
        listOfRestrictingEvents.map((event) => <EventRestrictingAlert key={event.uuid} event={event} />)}
      {showConflictsCard && (
        <AbsenceRequestConflictsCard
          // We are sure startDate and endDate are defined by validDates
          startDate={startDate as string}
          endDate={endDate as string}
          showAbsencePlannerDrawer={showAbsencePlannerDrawer}
          setShowAbsencePlannerDrawer={setShowAbsencePlannerDrawer}
          previewPerson={selectedPerson as Person}
          showAbsencePlannerPreview
        />
      )}
    </>
  )
}

export default NewAbsenceRequestAlertContent
